export default {
  translation: {
    modals: {
      deleteProductQuestion: "Are you sure to delete this product?",
      welcome:
        "You are now signed up into DAB systems. Log in to use this site",
      newUser: "Welcome to D.Shop",
      agentBudget:
        "You have chosen to use an agent's budget that will be changed based on the order you are making",
      orderSent: "Congratulations, you sent your order!",
      endBudget: "Attention, you've run out of budget for this year.",
      errorBudgetTitle: "Budget Error",
      errorBudgetDescription:
        "Wrong budget. If you think this is an error, contact the administrator.",
      orderRepeatModal: {
        buttonDetail: "Repeat Order",
        emptyCart: {
          title: "Products are added to the cart",
          button1: "Continue shopping",
          button2: "Go to the checkout",
        },
        notEmptyCart: {
          title: "Products already in the cart will be removed",
          description:
            "The products of the selected order will be added to the cart, you can add other products later",
          button1: "Cancel",
          button2: "Proceed",
        },
      },
    },
    buttons: {
      deleteProduct: "Delete product",
      cancel: "Cancel",
      getPdf: "Get summary PDF",
      completeRegistration: "Complete Registration",
      close: "Close",
      visitSite: "Visit Site",
      back: "< Back",
      getOrderPdf: "Get order PDF",
      proceedOrder: "Proceed to order",
      visitAfterOrder: "Continue visit site",
      goOrders: "Go to your orders",
      sendOrder: "Send order",
      addToCart: "Add to cart",
      goCheckout: "Go to checkout",
      resetCart: "Reset Cart",
      discoverMore: "Discover more",
    },
    errors: {
      cartError: "An error occurred retrieving the shopping cart",
      fieldsRegisterError: "Error(s) in form fields",
      formError: "An error occurred retrieving registration form",
      pageLoadingError: "An error occurred retrieving the page",
      generalError: "Something went wrong",
      purchaseError: "Something went wrong during th purchase",
      purchaseErrorDescription: "Reload the page, then retry",
      quantityPurchaseError: "Requested quantity not available",
      quantityPurchaseErrorDescription: "Select a smaller amount",
      listError: "An error occurred retrieving products",
      noProducts: "Products not found",
      noProductsDescription: "Please visit other categories",
      addressesError: "An error occurred retrieving addresses",
      addressNotFound: "Address not found. Retry with another name",
      sendOrderError: "An error occurred sending the order",
      sendOrderErrorDesc: "Try to reload the page and check all the data.",
      productError: "An error occurred retrieving product",
    },
    formFields: {
      vatField: "Vat Number",
      mainBusinessField: "Main Business Area",
      companyNameField: "Company Name",
      addressField: "Address",
      addressContField: "Address (cont.)",
      postalCodeField: "Postal Code",
      cityField: "City",
      provinceField: "Province",
      countryField: "Country",
    },
    content: {
      whyRegister: "Why you should register to our site?",
      filterType: "Filter by type",
      filterLanguage: "Filter by language",
      lastInsertedProducts: "Last inserted product",
      orderName: "Order by product name",
      orderDate: "Order by creation date",
      orderByType: "Order by type",
      orderBy: "Order by...",
      orderBudget: "Is your order for DTraining or for a Company?",
      orderBudgetDesc: "Select typology",
      orderLocation: "Is your order CEE or Extra-CEE?",
      orderLocationDesc: "Select typology",
      orderType: "Homage or sale?",
      orderTypeDesc: "Select typology",
      homage: "Homage",
      sale: "Sale",
      lastOrder: "Last delivery address",
      searchAddress: "Search address",
      order: "Order",
      orderNotes: "Order notes",
      editOrderNotes: "Edit order notes",
      addOrderNotes: "Add order notes",
      saveOrderNotes: "Save order notes",
      getPdfMail: "Get order summary PDF via email",
      articles: "Articles",
      addedItem: "You just added an item to the cart",
      documentation: "Documentation",
      getCatalogue: "Download demo",
      search: "Search",
      ourProduct: "Our Products",
      relatedProducts: "Products related to this item",
    },
    productDetail: {
      selectSize: "Select size",
      quantity: "Quantity",
      pieces: "Pieces",
      availability: "Warehouse availability",
      description: "Description",
      detail: "Detail",
    },
    orderTable: {
      totalPrice: "Total Price",
      orderDate: "Order Date",
      orderCode: "Order Code",
      customerName: "Customer Name",
      statusOrder: "Status",
      removed: "Removed from database",
      repeatOrder: "Repeat",
    },
    menu: {
      cart: "Shopping Cart",
      emptyCart: "Your shopping cart is empty.",
      emptyCartDesc:
        'To add articles to your shopping cart browse the categories: when you find an item that interest you, click on "Add To Cart". Item prices in your shopping cart always reflect the most recent price displayed on the relevant product pages.',
      signUp: "Sign Up",
      myOrders: "My orders",
      language: "Language",
      selectLanguage: "Select language",
      showPrices: "Show prices",
      select: "Select...",
      selectCurrency: "Select Currency",
      totalActual: "Current Total",
      totalAnnual: "Annual Total",
      editProfile: "Edit profile",
    },
  },
};



// WEBPACK FOOTER //
// ./src/I18n/locales/en.js